/**
 * Otokoç widget kit — branding, theme tokens, and i18n strings.
 *
 * Centralises every constant so both the IIFE bundle (production injector)
 * and the testchat SPA share a single source of truth.
 */

export const OTOKOC_LAUNCHER_AVATAR_URL =
  'https://configs.gengage.ai/otokoccomtr/voice-assistant.webp';
export const OTOKOC_DESKTOP_LAUNCHER_LABEL = 'Uzmanla Görüş';
export const DEFAULT_CHAT_PLACEHOLDER = 'Mesajınızı yazın...';
export const LEGACY_OPENING_SKU = 'default_sku';

export const OTOKOC_THEME = {
  primaryColor: '#0f2b5b',
  primaryForeground: '#ffffff',
  backgroundColor: '#ffffff',
  foregroundColor: '#1a1a2e',
  borderRadius: '8px',
  fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
  fontSize: '14px',
  zIndex: '1000000',
  '--client-primary': '#0f2b5b',
  '--client-primary-hover': 'color-mix(in srgb, #0f2b5b 88%, white 12%)',
  '--client-primary-active': 'color-mix(in srgb, #0f2b5b 78%, white 22%)',
  '--client-primary-subtle': 'color-mix(in srgb, #0f2b5b 10%, white)',
  '--client-primary-soft': 'color-mix(in srgb, #0f2b5b 18%, white)',
  '--client-on-primary': '#ffffff',
  '--client-focus-ring': 'color-mix(in srgb, #0f2b5b 28%, transparent)',
  '--gengage-z-index': '1000000',
  '--gengage-chat-launcher-size': '60px',
} as const;

export const OTOKOC_CHAT_I18N = {
  inputPlaceholder: DEFAULT_CHAT_PLACEHOLDER,
  poweredBy: 'Gengage',
  viewDetails: 'Detayları Öğren',
  productCtaLabel: 'Detayları Öğren',
} as const;
